@use "../../sass/global/global" as *;

ux-iws-link-wrapper {
    display: block;
}

.ux-iws-link-wrapper {
    &--with-link {
        cursor: pointer;
    }

    &:hover {
        /* stylelint-disable max-nesting-depth */
        .ux-button:not(.ux-button--primary):not(.ux-button--green):not(
                .ux-button--red
            ):not(.ux-iws-link-wrapper-ignore) {
            background: $color-black;
            color: $color-white;

            ux-icon {
                color: $color-white;
            }
        }

        .ux-button--primary:not(.ux-iws-link-wrapper-ignore),
        .ux-button--green:not(.ux-iws-link-wrapper-ignore) {
            background: $color-white;
            color: $color-green;

            ux-icon {
                color: $color-green;
            }
        }
        /* stylelint-enable max-nesting-depth */
    }
}
